export default __webpack_public_path__ + "static/media/additional-option-polyester-batting.44312e23.webp";